import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MockData } from '../../../mock';

@Injectable()
export class MockInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!environment.useMock || request.method !== "POST")
            return next.handle(request);

        let command = request.body["cmd"] && request.body["cmd"]["command"];
        if (!command)
            return next.handle(request);

        command = commandCamelCase(command);
        if (MockData[command]) {
            let params = request.body["cmd"]["params"]
            let mockedResult = MockData[command].response(params);
            if (mockedResult) {
                let response = new HttpResponse({
                    body: mockedResult,
                    status: 200
                })

                console.log('Mocked response', response);

                return of(response)
            }
        }

        return next.handle(request);
    }
}


function commandCamelCase(command) {
    return command.split(".")
        .map(t => t.charAt(0).toUpperCase() + t.slice(1))
        .join("");
}
